<template>
    
<div>
    <div class="bg-black/40 px-3 py-2 border-b border-white rounded-t-sm flex flex-col items-center">
        <router-link  class="hover:underline"
       :to="'/colles/'+colla.id"><h2 class="text-base text-center max-w-64 justify-center text-white">
            <strong>{{ colles[mostra].nom }}
            </strong>{{ " " }}
                <IcoTipEst :key="colles[mostra]" :colla="colles[mostra]" dada="tipus"/>{{ " " }}
                <IcoTipEst :key="colles[mostra]" :colla="colles[mostra]" dada="estat"/>
            </h2>
            <h2 class="text-base text-center max-w-64 justify-center text-white">
        <em class="text-sm" v-for="(malnom,index) in colla.malnoms" :key="index">{{ malnom }}<span v-if="index<colla.malnoms.length-1">, </span> </em></h2></router-link>
        </div>
            <div class="flex flex-row justify-center px-3 py-1">
                <router-link :to="'/colles/'+colla.id" class=" hover:bg-white/20 h-fit"><div class="my-auto" v-if="colles[mostra].xy_escut?.length" :style="{
                        width:'100px',
                        height: '100px',  
                        backgroundImage: `url(${escutsSprite})`, 
                        backgroundPosition: `${-100*colles[mostra].xy_escut[0]}px ${-100*colles[mostra].xy_escut[1]}px`,
                        backgroundSize: 100*12+'px'           
                    }
                        ">
                </div></router-link>
                <div class="text-sm text-center max-w-40">
                    <p>  
                        <strong>{{ colles[mostra].color_camisa }}</strong><br>
                        
                        <strong>Localitat:</strong> {{ colla.localitat }}<br>
                        <strong>Tipus:</strong> {{ formatDada(colla.tipus) }}<br>
                        <strong>Estat:</strong> {{ formatDada(colles[mostra].estat) }}<br>
                        <span v-if="colles.length>1">
                        <strong>Fundació original:</strong> {{ colla.fundacio_original }}

                        <span v-if="colles[mostra]!=colles[0]"><strong>Refundació:</strong> {{ colles[mostra].fundacio }}</span>

                        </span>
                        <span v-else> 
                        <strong>Fundació:</strong> {{ colla.fundacio_original }}    
                        </span>
                    </p>
                    <p v-if="colles[mostra].estat=='desapareguda'"><strong>
                        Desaparició:
                    </strong>
                    <span v-if="colles[mostra].desaparicio!==-1">{{ colles[mostra].desaparicio }}</span>
                    <span v-else>Desconegut</span><br>
                    </p>

                    

                    <p class="my-1 text-xl text-white icons gap-2 flex justify-center">
                    <a class="text-white opacity-70 hover:opacity-100" 
                        title="Pàgina Web de la Colla" v-if="colla.web!==null" 
                        :href="'https://'+colla.web" 
                        target="_blank" alt="Pàgina Web de la Colla">
                            <font-awesome-icon :icon="['fas','globe']"/>
                    </a>
                    <a  v-if="colla.instagram!==null" 
                        title="Pàgina d'Instagram de la Colla"
                        alt="Pàgina d'Instagram de la Colla"
                        class="text-white opacity-70 hover:opacity-100"
                        :href="'https://www.instagram.com/'+colla.instagram" target="_blank">
                        <font-awesome-icon :icon="['fab', 'instagram']"/>
                    </a>
                    <a  v-if="colla.twitter!==null" 
                        title="Pàgina de Twitter de la Colla"
                        alt="Pàgina de Twitter de la Colla"
                        class="text-white opacity-70 hover:opacity-100"
                        :href="'https://www.x.com/'+colla.twitter" target="_blank">
                        <font-awesome-icon :icon="['fab', 'x-twitter']"/>
                    </a>
                    <a  v-if="colla.facebook!==null" 
                        title="Pàgina de Facebook de la Colla"
                        alt="Pàgina de Facebook de la Colla"
                        class="text-white opacity-70 hover:opacity-100"
                        :href="'https://www.facebook.com/'+colla.facebook" target="_blank">
                        <font-awesome-icon :icon="['fab', 'facebook']"/>
                    </a>
                    <a  v-if="colla.youtube!==null" 
                        title="Pàgina de YouTube de la Colla"
                        alt="Pàgina de YouTube de la Colla"
                        class="text-white opacity-70 hover:opacity-100"
                        :href="'https://www.youtube.com/@'+colla.youtube" target="_blank">
                        <font-awesome-icon :icon="['fab', 'youtube']"/>
                    </a>
                    <a title="Article Wikipedia de la Colla"
                        alt="Article Wikipedia de la Colla"
                        class="text-white opacity-70 hover:opacity-100"
                        :href="colla.wikipedia!==null?'https://ca.wikipedia.org/w/index.php?title='+colla.wikipedia:'https://ca.wikipedia.org/w/index.php?title='+colla.nom+'&action=edit&redlink=1'" target="_blank">
                        <font-awesome-icon :icon="['fab', 'wikipedia-w']"/></a>
                </p> </div>
       

    </div>
    <div v-if="colles.length > 1"  class="flex mx-auto justify-center gap-1 px-3 pb-2">
            <button v-for="(colla,index) in colles" :key="index" class="flex flex-col items-center hover:bg-white/20 p-1 rounded-sm" @mousedown.prevent="mostra=index">
            <div :style="{backgroundColor:colla.codi_color}" class="aspect-square h-6 border-solid border border-1 self-center" :title="colla.nom"></div>
            <span class="text-xs font-bold">{{ colla.fundacio }}</span>
        </button>
        </div>
</div>
</template>

<script setup>
import { ref,inject,computed,onMounted,defineProps } from 'vue'
import IcoTipEst from './IcoTipEst.vue'
const props = defineProps({
    colla:{
        type: Object,
        required: true
    }
})
const escutsSprite = inject('escutsSprite')
let mostra = ref(0)
    const colles = computed(()=>{
        const muntat = []
        if (props.colla.predecesores.length>0){
            muntat.push(...props.colla.predecesores)
            muntat.push(props.colla)
            
            return muntat
        }
        else{
            muntat.push(props.colla)
            return muntat
        }
    })

    if (colles.value!==null) mostra.value=colles.value.length-1
    
    function fundacioOriginal(perfil){
perfil.fundacio_original = Math.min(
perfil.fundacio,
...(perfil.predecesores || []).map(c => c.fundacio)
)
}

    function formatDada(estat){
        const mapaFormats={
            //Tipus
            convencional:"Convencional",
            universitaria:"Universitària",
            internacional:"Internacional",

            //Estats
            activa:"Activa",
            formacio:"En formació",
            desapareguda:"Desapareguda"
        };
        return mapaFormats[estat]|| "Desconegut"
    }

    onMounted(()=>{
        if(props.colla)fundacioOriginal(props.colla)
    }
)
        

</script>

<style>

.tippy-box{
    background-color:rgba(0, 0, 0, 0.5);
    border-radius:  0.25rem;
    
}
.tippy-content{
    padding:0px;
}

</style>